import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const LastName = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  return (
    <TextInput
      label="Last Name *"
      value={fieldData.lastName}
      error={'lastName' in formErrors ? formErrors.lastName.message : undefined}
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            lastName: { message: 'Field is required' }
          });
        else {
          const errors = { ...formErrors };
          delete errors.lastName;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          lastName: value
        }));
      }}
    />
  );
};

LastName.propTypes = {
  formErrors: PropTypes.shape({
    lastName: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default LastName;
